import JDictSelectTagComp from './JDictSelectTag.vue'
import JDictCodeSelectTagComp from './JDictCodeSelectTag.vue'

const JDictSelectTag = {
  install: function (Vue) {
    Vue.component('JDictSelectTag', JDictSelectTagComp);
    Vue.component('JDictCodeSelectTag', JDictCodeSelectTagComp);
  }
}

export default JDictSelectTag;